import { CREATE_CHARITY_REQUEST } from "./charityRequest.types";

export const createCharityRequest = (body) => {
  return {
    type: CREATE_CHARITY_REQUEST,
    payload: { body },
  };
};
